module.exports = __webpack_public_path__ + "img/phone.015b4248.png";